// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailsRow_root__1gn1P"};